import { OverlayTrigger, Tooltip } from "react-bootstrap";
import RoleBadge from "../role-badge/RoleBadge";

type Props = {
  className?: string;
};

const InternalBadge = ({ className }: Props) => (
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip id="internal-tooltip">Visible for internal user only.</Tooltip>
    }
  >
    <span>
      <RoleBadge name="Internal" className={className} />
    </span>
  </OverlayTrigger>
);

export default InternalBadge;
